export default {
  state() {
    return {
      prestadorObject: null
    };
  },
  getters: {
    getPrestador(state) {
      return state.prestadorObject;
    },
    getMostrarCamposQualificacao(state) {
      if (!state.prestadorObject) return false;

      if (
        state.prestadorObject.tipo.chave === "MEDICO" ||
        state.prestadorObject.tipo.chave === "PESSOA_FISICA"
      ) {
        return true;
      }

      return false;
    }
  },
  mutations: {
    setPrestador(state, payload) {
      state.prestadorObject = payload;
    }
  }
};
